import { render, staticRenderFns } from "./GerenciarQuizzes.vue?vue&type=template&id=166d9bb0&scoped=true&"
import script from "./GerenciarQuizzes.vue?vue&type=script&lang=js&"
export * from "./GerenciarQuizzes.vue?vue&type=script&lang=js&"
import style0 from "./GerenciarQuizzes.vue?vue&type=style&index=0&id=166d9bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d9bb0",
  null
  
)

export default component.exports